// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://fabritech-web-backend.vercel.app/api';

// Debug: Log the API URL being used (remove in production if needed)
console.log('API Base URL:', API_BASE_URL);

// Sign-in endpoints answer 401 for a wrong password; that must not end the session
const AUTH_ENDPOINTS = ['/users/login', '/users/register', '/users/google'];

/** JWT saved at sign-in (see AuthContext), or null. */
export const getAuthToken = () => {
  try {
    return localStorage.getItem('token');
  } catch (_) {
    return null;
  }
};

/** Authorization header for requests that don't go through fetch (e.g. XMLHttpRequest uploads). */
export const authHeader = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

let redirectingToLogin = false;

/**
 * Clear the session and send the user to the login page.
 * reason: 'expired' (token expired/revoked), 'idle' (inactivity timeout) or 'signedout'.
 * The login page shows a matching message and returns the user to where they were.
 */
export function endSession(reason = 'expired') {
  if (redirectingToLogin) return;
  redirectingToLogin = true;
  try {
    ['user', 'token', 'isAuthenticated', 'cart', 'wishlist', 'lastActivity'].forEach((key) => localStorage.removeItem(key));
  } catch (_) {
    // ignore
  }
  if (window.location.pathname !== '/login') {
    const from = window.location.pathname + window.location.search;
    window.location.assign(`/login?session=${reason}&from=${encodeURIComponent(from)}`);
  }
}

/**
 * Every request to the API carries the signed-in user's token automatically
 * ("Authorization: Bearer <token>"). A 401 answer on a signed-in request ends the session.
 */
if (typeof window !== 'undefined' && !window.__fabritechAuthFetch) {
  window.__fabritechAuthFetch = true;
  const nativeFetch = window.fetch.bind(window);

  window.fetch = async (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (!url.startsWith(API_BASE_URL)) return nativeFetch(input, init);

    const token = getAuthToken();
    const headers = new Headers(init.headers || (input instanceof Request ? input.headers : undefined));
    if (token && !headers.has('Authorization')) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    const response = await nativeFetch(input, { ...init, headers });

    const isSignInRequest = AUTH_ENDPOINTS.some((path) => url.startsWith(API_BASE_URL + path));
    if (response.status === 401 && token && !isSignInRequest) {
      endSession();
    }
    return response;
  };
}

export default API_BASE_URL;
